export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
  case 'STORE_FCMTOKEN':
    return payload
  case 'LOGOUT':
    return []
  default:
    return state
  }
}
